import React from 'react'
import ListUnpushKitCardPage from './ListUnpushKitCardPage'
import '../styles/index.scss'

const ListUnpushKitCardContainer = () => {
    return (
        <div className='ListUnpushKitCardContainer'>
            <ListUnpushKitCardPage />
        </div>
    )
}

export default ListUnpushKitCardContainer